module.exports = __webpack_public_path__ + "img/government_zhongyang.cfefa85c.png";